"use client";

import { useState, useCallback, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/navigation/Navbar";
import FloatingDock from "@/components/navigation/FloatingDock";
import DynamicIsland from "@/components/landing/DynamicIsland";
import { ChatWindow } from "@/components/chat/ChatWindow";
import { useOverlayStore } from "@/lib/overlay-store";
import { cn } from "@/lib/utils";
import { useAuth } from "@/components/AuthProvider";
import { useTenant } from "@/components/TenantProvider";

export default function ClientLayout() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { tenant } = useTenant();
  const [notification, setNotification] = useState<{ message: string; visible: boolean }>({ message: "", visible: false });
  const dismissNotification = useCallback(() => setNotification((prev) => ({ ...prev, visible: false })), []);
  const resetOverlays = useOverlayStore((s) => s.activeCount > 0);

  useEffect(() => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflowY = "";
    if (resetOverlays) { useOverlayStore.setState({ activeCount: 0 }); }
  }, [location.pathname]);

  useEffect(() => {
    document.title = tenant.settings.siteTitle || tenant.name;
  }, [tenant]);

  return (
    <div className="relative min-h-screen bg-light-bg dark:bg-dark-bg">
      {tenant.settings.features?.notifications !== false && <DynamicIsland message={notification.message} visible={notification.visible} onDismiss={dismissNotification} autoDismissMs={5000} />}
      <Navbar />
      <main className={cn("pb-24")}><Outlet /></main>
      <FloatingDock />
      {isAuthenticated && tenant.settings.features?.chat !== false && <ChatWindow />}
    </div>
  );
}
